/**
 * Quick view modal (opens product URL in modal shell)
 */
(function () {
  const modal = document.getElementById('QuickViewModal');
  if (!modal) return;

  const content = modal.querySelector('[data-quick-view-content]');

  function open(url) {
    content.innerHTML = '<p class="text-muted" style="padding:2rem;">Loading...</p>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const product = doc.querySelector('.product-page');
        content.innerHTML = product ? product.outerHTML : '<p>Unable to load product.</p>';
      })
      .catch(() => {
        content.innerHTML = '<p>Unable to load product.</p>';
      });
  }

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (trigger) {
      e.preventDefault();
      open(trigger.dataset.quickView || trigger.href);
    }
    if (e.target.closest('[data-modal-close]')) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();
